<template>
  <div>
    <b-card>
      <b-row align-h="center">
        <b-col cols="12">
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.activeTaskColor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.cancelTaskColor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.movedTaskColor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.returnedTaskColor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.taskInfo')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.roleUserForContractor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.isHeadquartersTypeForContractor')}}</th>
              <th class="text-center">{{$t('views.appconfiguration.generalConfiguration.clientTypesForPartnerUserData')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th class="text-center">
                <el-color-picker v-model="configuration.activeDailyPlanItemColor"></el-color-picker>
              </th>
              <th class="text-center">
                <el-color-picker v-model="configuration.cancelledDailyPlanItemColor"></el-color-picker>
              </th>
              <th class="text-center">
                <el-color-picker v-model="configuration.movedDailyPlanItemColor"></el-color-picker>
              </th>
              <th class="text-center">
                <el-color-picker v-model="configuration.returnedDailyPlanItemColor"></el-color-picker>
              </th>
              <th class="text-center">
                <b-form-group>
                  <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_display" v-model="configuration.autoTakeTaskAfterEnter" name="checkbox_display">
                    <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                    <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </th>
              <th class="text-center">
                <b-form-group>
                  <model-select :options="clientTypesOptions" v-model="configuration.idClientTypeForContractorsView"></model-select>
                </b-form-group>
              </th>
              <th class="text-center">
                <b-form-group>
                  <model-select :options="firmTypes" v-model="configuration.isHeadquartersForContractorsView"></model-select>
                </b-form-group>
              </th>
              <th>
                <b-form-checkbox-group
                  v-model="configuration.clientTypesForPartnerUserData"
                  :options="clientTypesForPartnerUserDataOptions"
                  stacked
                ></b-form-checkbox-group>
              </th>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-card>
    <br>
    <b-card>
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab b-tab :title="$t('views.appconfiguration.tabs.ownerConfiguration')">
          <h6 class="mb-2"><strong>{{$t('views.appconfiguration.ownerConfiguration.companyData')}}</strong></h6>
          <b-row>
            <b-col sm="12" lg="4">
              <label
                for="titlePartOne"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.titlePartOne') }}:</label>
              <input
                id="titlePartOne"
                v-model="configuration.titlePartOne"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="titlePartTwo"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.titlePartTwo') }}:</label>
              <input
                id="titlePartTwo"
                v-model="configuration.titlePartTwo"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="nip"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.nip') }}:</label>
              <input
                id="nip"
                v-model="configuration.nip"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col sm="12" lg="4">
              <label
                for="regon"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.regon') }}:</label>
              <input
                id="regon"
                v-model="configuration.regon"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="phone"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.phone') }}:</label>
              <input
                id="phone"
                v-model="configuration.phone"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="userEmail"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.email') }}:</label>
              <input
                id="userEmail"
                v-model="configuration.userEmail"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col sm="12" lg="4">
              <label
                for="bankName"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.bankName') }}:</label>
              <input
                id="bankName"
                v-model="configuration.bankName"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="bankAccount"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.numberBankAccount') }}:</label>
              <input
                id="bankAccount"
                v-model="configuration.bankAccount"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="email"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.vatPayer') }}:</label>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_display" v-model="configuration.vatPayer" name="checkbox_display">
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <h6 class="mb-2 mt-3"><strong>{{$t('views.appconfiguration.ownerConfiguration.companyAddress')}}</strong></h6>
          <b-row>
            <b-col sm="12" lg="4">
              <label
                for="numberLocal"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.number') }}:</label>
              <input
                id="numberLocal"
                v-model="configuration.numberLocal"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="place"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.place') }}:</label>
              <input
                id="place"
                v-model="configuration.place"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="street"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.street') }}:</label>
              <input
                id="street"
                v-model="configuration.street"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12" lg="4">
              <label
                for="city"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.city') }}:</label>
              <input
                id="city"
                v-model="configuration.city"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="postcode"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.postcode') }}:</label>
              <input
                id="postcode"
                v-model="configuration.postcode"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="county"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.county') }}:</label>
              <input
                id="county"
                v-model="configuration.county"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="12" lg="4">
              <label
                for="province"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.province') }}:</label>
              <input
                id="province"
                v-model="configuration.province"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col sm="12" lg="4">
              <label
                for="country"
                class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.country') }}:</label>
              <input
                id="country"
                v-model="configuration.country"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <div>
                <b-btn v-b-toggle.collapse-1 size="sm" variant="primary">
                  <span class="when-opened">{{$t('views.appconfiguration.ownerConfiguration.contactPerson')}}</span>
                </b-btn>
                <b-collapse id="collapse-1">
                  <b-row class="mt-3">
                    <b-col sm="12" lg="6">
                      <label
                        for="companyContactPersonName"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyContactPersonName') }}:</label>
                      <input
                        id="companyContactPersonName"
                        v-model="configuration.companyContactPersonName"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                    <b-col sm="12" lg="6">
                      <label
                        for="companyContactPersonSurname"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyContactPersonSurname') }}:</label>
                      <input
                        id="companyContactPersonSurname"
                        v-model="configuration.companyContactPersonSurname"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="12" lg="6">
                      <label
                        for="companyContactPersonPhone"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyContactPersonPhone') }}:</label>
                      <input
                        id="companyContactPersonPhone"
                        v-model="configuration.companyContactPersonPhone"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                    <b-col sm="12" lg="6">
                      <label
                        for="companyContactPersonPosition"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyContactPersonPosition') }}:</label>
                      <input
                        id="companyContactPersonPosition"
                        v-model="configuration.companyContactPersonPosition"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                  </b-row>
                </b-collapse>
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <div>
                <b-btn v-b-toggle.collapse-2 size="sm" variant="primary">
                  <span class="when-opened">{{$t('views.appconfiguration.ownerConfiguration.representativePerson')}}</span>
                </b-btn>
                <b-collapse id="collapse-2">
                  <b-row class="mt-3">
                    <b-col sm="12" lg="6">
                      <label
                        for="companyRepresentativePersonName"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyRepresentativePersonName') }}:</label>
                      <input
                        id="companyRepresentativePersonName"
                        v-model="configuration.companyRepresentativePersonName"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                    <b-col sm="12" lg="6">
                      <label
                        for="companyRepresentativePersonSurname"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyRepresentativePersonSurname') }}:</label>
                      <input
                        id="companyRepresentativePersonSurname"
                        v-model="configuration.companyRepresentativePersonSurname"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col sm="12" lg="6">
                      <label
                        for="companyRepresentativePersonPhone"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyRepresentativePersonPhone') }}:</label>
                      <input
                        id="companyRepresentativePersonPhone"
                        v-model="configuration.companyRepresentativePersonPhone"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                    <b-col sm="12" lg="6">
                      <label
                        for="companyRepresentativePersonPosition"
                        class="form-control-label">{{ $t('views.appconfiguration.ownerConfiguration.companyRepresentativePersonPosition') }}:</label>
                      <input
                        id="companyRepresentativePersonPosition"
                        v-model="configuration.companyRepresentativePersonPosition"
                        :class="['form-control']"
                        type="text"
                        placeholder=""
                      >
                    </b-col>
                  </b-row>
                </b-collapse>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab b-tab :title="$t('views.appconfiguration.tabs.invoiceConfiguration')" v-if="configuration.invoiceSettings">
          <b-row>
            <b-col sm="12" lg="6">
              <label
                for="documentType"
                class="form-control-label">{{ $t('views.appconfiguration.invoiceConfiguration.invoiceType') }}:</label>
              <fg-input>
                <el-select
                  class="select-default"
                  filterable
                  remote
                  reserve-keyword
                  v-model="configuration.invoiceSettings.invoiceType">
                  <el-option v-for="option in invoiceTypeOptions"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
            </b-col>
            <b-col sm="12" lg="6">
              <label
                for="documentType"
                class="form-control-label">{{ $t('views.appconfiguration.invoiceConfiguration.documentType') }}:</label>
              <b-form-group>
                <model-select :options="documentType" v-model="configuration.invoiceSettings.documentType"></model-select>
              </b-form-group>
            </b-col>
            <b-col sm="12" lg="6">
              <label
                for="issuePlace"
                class="form-control-label">{{ $t('views.appconfiguration.invoiceConfiguration.issuePlace') }}:</label>
              <input
                id="issuePlace"
                v-model="configuration.invoiceSettings.issuePlace"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12" lg="6">
              <label
                for="comment"
                class="form-control-label">{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}:</label>
              <input
                id="comment"
                v-model="configuration.invoiceSettings.comments"
                :class="['form-control']"
                type="text"
                placeholder=""
              >
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label for="custom_email_content">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
                <input
                  id="issuePlace"
                  v-model="configuration.invoiceSettings.invoiceMailTitle"
                  :class="['form-control']"
                  type="text"
                  placeholder=""
                >
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
                <trumbowyg ref="editor" v-model="configuration.invoiceSettings.customEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
                </trumbowyg>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12">
              <b-form-group>
                <label for="custom_email_content">{{ $t('views.appconfiguration.invoiceConfiguration.invoiceVindicationMailTitle') }}:</label>
                <input
                  id="invoiceVindicationMailTitle"
                  v-model="configuration.invoiceSettings.invoiceVindicationMailTitle"
                  :class="['form-control']"
                  type="text"
                  placeholder=""
                >
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <content-field-invoices-legend></content-field-invoices-legend>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label for="custom_vindication_email">{{ $t('views.appconfiguration.invoiceConfiguration.customVindicationEmail') }}:</label>
                <trumbowyg ref="editor" v-model="configuration.invoiceSettings.customVindicationEmail" :config="trumbowygConfig" class="form-control" name="customVindicationEmail">
                </trumbowyg>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label for="custom_email_content">{{ $t('views.appconfiguration.invoiceConfiguration.customVindicationSms') }}:</label>
                <input
                  id="customVindicationSms"
                  v-model="configuration.invoiceSettings.customVindicationSms"
                  :class="['form-control']"
                  type="text"
                  placeholder=""
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" lg="2">
              <label>{{$t("views.appconfiguration.invoiceConfiguration.interestStatus")}}:</label>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="interestStatus" v-model="configuration.invoiceSettings.interestStatus" name="interestStatus">
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" lg="10" v-if="configuration.invoiceSettings.interestStatus === 1">
              <label>{{$t("views.appconfiguration.invoiceConfiguration.interest")}}:</label>
              <b-form-input v-model="configuration.invoiceSettings.interest" type="text" :placeholder="$t('views.appconfiguration.invoiceConfiguration.interest')" class="form-control"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('views.appconfiguration.ownerConfiguration.ksefEnabled')}}:</label><br>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="ksefEnabled" v-model="configuration.ksefEnabled" name="ksefEnabled">
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.appconfiguration.ownerConfiguration.ksefDisabled')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.appconfiguration.ownerConfiguration.ksefTest')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.appconfiguration.ownerConfiguration.ksefDemo')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="3">{{$t('views.appconfiguration.ownerConfiguration.ksefProd')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col v-if="configuration.ksefEnabled">
              <label>{{$t('views.appconfiguration.ownerConfiguration.sendAllToKsef')}}:</label><br>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="sendAllToKsef" v-model="configuration.sendAllToKsef" name="sendAllToKsef">
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.yes')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="configuration.ksefEnabled">
              <label>{{ $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationType') }}:</label><br>
              <b-form-group class="mb-0">
                <b-form-radio-group
                  id="ksefAuthorizationType"
                  v-model="configuration.ksefAuthorizationType"
                  name="ksefAuthorizationType"
                  buttons
                  button-variant="outline-primary"
                >
                  <b-form-radio :value="1">
                    {{ $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationCertificate') }}
                  </b-form-radio>
                  <b-form-radio :value="0">
                    {{ $t('views.appconfiguration.ownerConfiguration.ksefAccessTokenSelection') }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="configuration.ksefEnabled && configuration.ksefAuthorizationType === 0">
              <b-form-group
                class="mt-4"
                :label="$t('views.appconfiguration.ownerConfiguration.ksefAccessToken')"
              >
                <b-form-input
                  v-model="configuration.ksefAccessToken"
                  :placeholder="configuration.ksefAccessTokenPresent ? '••••••••••' : ''"
                />
              </b-form-group>
              <b-alert show variant="warning" class="m-3">
                {{ $t('views.appconfiguration.ownerConfiguration.ksefOfflineCertificateNeeded') }}
              </b-alert>
            </b-col>
            <b-col cols="12" v-if="configuration.ksefEnabled && configuration.ksefAuthorizationType === 1">
              <h4 class="mt-5">
                {{ $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationCertificates') }}
              </h4>
              <b-form-group
                :label="$t('views.appconfiguration.ownerConfiguration.ksefAuthorizationCertificate')"
              >
                <b-form-file
                  v-model="configuration.ksefAuthorizationCertificateFile"
                  name="ksefAuthorizationCertificate"
                  accept=".crt"
                  :placeholder="configuration.ksefAuthorizationCertificatePresent
                ? $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationKeyPresent')
                : ''"
                  @input="onFileChange($event, 'ksefAuthorizationCertificate')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('views.appconfiguration.ownerConfiguration.ksefAuthorizationPrivateKey')"
              >
                <b-form-file
                  v-model="configuration.ksefAuthorizationPrivateKeyFile"
                  name="ksefAuthorizationPrivateKey"
                  accept=".key"
                  :placeholder="configuration.ksefAuthorizationPrivateKeyPresent
                ? $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationKeyPresent')
                : ''"
                  @input="onFileChange($event, 'ksefAuthorizationPrivateKey')"
                />
              </b-form-group>
              <b-form-group
                class="mb-4"
                :label="$t('views.appconfiguration.ownerConfiguration.ksefAuthorizationPassphrase')"
              >
                <b-form-input
                  v-model="configuration.ksefAuthorizationPassphrase"
                  type="password"
                  :placeholder="configuration.ksefAuthorizationPassphrasePresent ? '••••••••' : ''"
                />
              </b-form-group>
              <h4 class="mt-5">
                {{ $t('views.appconfiguration.ownerConfiguration.ksefSigningCertificates') }}
              </h4>
              <b-form-group
                :label="$t('views.appconfiguration.ownerConfiguration.ksefSigningCertificate')"
              >
                <b-form-file
                  v-model="configuration.ksefSigningCertificateFile"
                  name="ksefSigningCertificate"
                  accept=".crt"
                  :placeholder="configuration.ksefSigningCertificatePresent
                ? $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationKeyPresent')
                : ''"
                  @input="onFileChange($event, 'ksefSigningCertificate')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('views.appconfiguration.ownerConfiguration.ksefSigningPrivateKey')"
              >
                <b-form-file
                  v-model="configuration.ksefSigningPrivateKeyFile"
                  name="ksefSigningPrivateKey"
                  accept=".key"
                  :placeholder="configuration.ksefSigningPrivateKeyPresent
                ? $t('views.appconfiguration.ownerConfiguration.ksefAuthorizationKeyPresent')
                : ''"
                  @input="onFileChange($event, 'ksefSigningPrivateKey')"
                />
              </b-form-group>
              <b-form-group
                class="mb-4"
                :label="$t('views.appconfiguration.ownerConfiguration.ksefSigningPassphrase')"
              >
                <b-form-input
                  v-model="configuration.ksefSigningPassphrase"
                  type="password"
                  :placeholder="configuration.ksefSigningPassphrasePresent ? '••••••••' : ''"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="configuration.ksefEnabled">
              <label>{{ $t('views.appconfiguration.ownerConfiguration.ksefUnavailableMode') }}:</label><br>
              <b-form-group class="mb-0">
                <b-form-radio-group
                  id="ksefUnavailableMode"
                  v-model="configuration.ksefUnavailableMode"
                  name="ksefUnavailableMode"
                  buttons
                  button-variant="outline-primary"
                >
                  <b-form-radio :value="0">
                    {{ $t('buttons.off') }}
                  </b-form-radio>
                  <b-form-radio :value="1">
                    {{ $t('buttons.on') }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-alert show variant="info" class="mt-3">
                {{ $t('views.appconfiguration.ownerConfiguration.ksefUnavaliableModeInfo') }}
              </b-alert>
            </b-col>
            <b-col cols="12" v-if="configuration.ksefEnabled">
              <b-form-group>
                <label for="ksef_email">{{ $t('views.appconfiguration.invoiceConfiguration.ksefEmail') }}:</label>
                <trumbowyg ref="editor" v-model="configuration.invoiceSettings.ksefEmail" :config="trumbowygConfig" class="form-control" name="ksefEmail">
                </trumbowyg>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
          </b-row>
        </b-tab>
        <b-tab b-tab :title="$t('views.appconfiguration.tabs.mailerLiteOptions')">
          <b-row>
            <b-col sm="12" lg="2">
              <label>{{$t("views.appconfiguration.ownerConfiguration.mailerLiteConnect")}}:</label>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="mailerLiteStatus" v-model="configuration.mailerLiteStatus" name="mailerLiteStatus">
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" lg="10" v-if="configuration.mailerLiteStatus === 1">
              <label>{{$t("views.appconfiguration.ownerConfiguration.mailerLiteApiKey")}}:</label>
              <b-form-input v-model="configuration.mailerLiteApiKey" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.mailerLiteApiKey')" class="form-control"></b-form-input>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab b-tab :title="$t('views.appconfiguration.tabs.autoReportingOptions')">
          <b-row>
            <b-col cols="12">
              <label>{{$t("views.appconfiguration.ownerConfiguration.autoReporting")}}:</label>
              <b-form-group>
                <b-form-radio-group buttons button-variant="outline-primary" id="autoReporting" v-model="configuration.autoReporting" name="autoReporting">
                  <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
                  <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <template v-if="configuration.autoReporting">
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpAddress")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpAddress" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpAddress')" class="form-control"></b-form-input>
              </b-col>
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpPort")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpPort" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpPort')" class="form-control"></b-form-input>
              </b-col>
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpConType")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpConType" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpConType')" class="form-control"></b-form-input>
              </b-col>
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpUser")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpUser" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpUser')" class="form-control"></b-form-input>
              </b-col>
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpPass")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpPass" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpPass')" class="form-control"></b-form-input>
              </b-col>
              <b-col sm="12" lg="2">
                <label>{{$t("views.appconfiguration.ownerConfiguration.autoReportingFtpDirectory")}}:</label>
                <b-form-input v-model="configuration.autoReportingFTP.ftpDirectory" type="text" :placeholder="$t('views.appconfiguration.ownerConfiguration.autoReportingFtpDirectory')" class="form-control"></b-form-input>
              </b-col>
              <b-col>
                <label>{{ $t('views.downloaddata.index.info') }}:</label>
                <b-form-group>
                  <b-form-checkbox-group
                    style="column-count: 3; max-height: 350px"
                    stacked
                    id="checkbox-group-1"
                    v-model="configuration.autoReportingList"
                    :options="selectedDataOptions"
                    name="flavour-1"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </template>
          </b-row>
        </b-tab>
        <b-tab v-if="checkRoles('exabagreements', 'EXABSurveysList')" :title="$t('routes.EXABSurveysList')">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="ksef_email">{{ $t('views.appconfiguration.invoiceConfiguration.externalSurveyEmailContent') }}:</label>
                <trumbowyg ref="editor" v-model="configuration.externalSurveyEmailContent" :config="trumbowygConfig" class="form-control" name="externalSurveyEmailContent">
                </trumbowyg>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <br>
        <b-row>
          <b-col>
            <button type="button" class="btn btn-primary" @click="submit()">{{ $t('buttons.save') }}</button>
          </b-col>
        </b-row>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ApiService from '@/utils/ApiService'
import { ModelSelect } from 'vue-search-select'
import { mapActions, mapGetters } from 'vuex'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import ContentFieldInvoicesLegend from '@/components/Dashboard/Views/Pages/AppConfiguration/components/contentFieldInvoicesLegend'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'AppConfiguration',
  components: {
    ContentFieldInvoicesLegend,
    ModelSelect,
    Trumbowyg
  },
  data () {
    return {
      tabIndex: 0,
      clientTypesOptions: [],
      documentType: [
        { value: 1, text: this.$t('views.appconfiguration.invoiceConfiguration.salesInvoice') },
        { value: 2, text: this.$t('views.appconfiguration.invoiceConfiguration.purchaseInvoice') }
      ],
      invoiceType: [
        { value: 1, text: this.$t('views.appconfiguration.invoiceConfiguration.vatInvoice') },
        { value: 2, text: this.$t('views.appconfiguration.invoiceConfiguration.notVatInvoice') }
      ],
      firmTypes: [
        { value: 0, text: this.$t('views.firm.form.types.department') },
        { value: 1, text: this.$t('views.firm.form.types.headquarters') }
      ],
      selectedDataOptions: [
        { value: 1, text: this.$t('views.downloaddata.index.options.excm_case') },
        { value: 2, text: this.$t('views.downloaddata.index.options.excm_case_type') },
        { value: 3, text: this.$t('views.downloaddata.index.options.excm_custom_field') },
        { value: 4, text: this.$t('views.downloaddata.index.options.excm_custom_field_value') },
        { value: 5, text: this.$t('views.downloaddata.index.options.excm_dailyplanitem') },
        { value: 6, text: this.$t('views.downloaddata.index.options.excm_documentfile') },
        { value: 7, text: this.$t('views.downloaddata.index.options.excm_message') },
        { value: 8, text: this.$t('views.downloaddata.index.options.excm_message_contentemail') },
        { value: 9, text: this.$t('views.downloaddata.index.options.excm_note') },
        { value: 10, text: this.$t('views.downloaddata.index.options.excm_pool_tasks') },
        { value: 11, text: this.$t('views.downloaddata.index.options.excm_notification_message') },
        { value: 12, text: this.$t('views.downloaddata.index.options.excm_region') },
        { value: 13, text: this.$t('views.downloaddata.index.options.excm_region_userdata') },
        { value: 14, text: this.$t('views.downloaddata.index.options.excm_status') },
        { value: 15, text: this.$t('views.downloaddata.index.options.excm_tag') },
        { value: 16, text: this.$t('views.downloaddata.index.options.excm_task') },
        { value: 17, text: this.$t('views.downloaddata.index.options.excm_task_type') },
        { value: 18, text: this.$t('views.downloaddata.index.options.excm_team') },
        { value: 19, text: this.$t('views.downloaddata.index.options.excm_team_userdata') },
        { value: 20, text: this.$t('views.downloaddata.index.options.exsb_item_type') },
        { value: 21, text: this.$t('views.downloaddata.index.options.exsb_items') },
        { value: 22, text: this.$t('views.downloaddata.index.options.exsb_items_brand') },
        { value: 23, text: this.$t('views.downloaddata.index.options.exsb_measure') },
        { value: 24, text: this.$t('views.downloaddata.index.options.exsb_order') },
        { value: 25, text: this.$t('views.downloaddata.index.options.exsb_order_status') },
        { value: 26, text: this.$t('views.downloaddata.index.options.exsb_order_tag') },
        { value: 27, text: this.$t('views.downloaddata.index.options.exsb_position') },
        { value: 28, text: this.$t('views.downloaddata.index.options.exsb_vat_rate') },
        { value: 29, text: this.$t('views.downloaddata.index.options.fos_user') },
        { value: 30, text: this.$t('views.downloaddata.index.options.fos_user_data') },
        { value: 31, text: this.$t('views.downloaddata.index.options.fos_user_data_address') },
        { value: 32, text: this.$t('views.downloaddata.index.options.userdata_employee') },
        { value: 33, text: this.$t('views.downloaddata.index.options.client_type') },
        { value: 34, text: this.$t('views.downloaddata.index.options.document_type') }
      ],
      clientTypesForPartnerUserDataOptions: [],
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      },
      configuration: {
        activeDailyPlanItemColor: '',
        cancelledDailyPlanItemColor: '',
        movedDailyPlanItemColor: '',
        returnedDailyPlanItemColor: '',
        postcode: '',
        idClientTypeForContractorsView: null,
        isHeadquartersForContractorsView: 0,
        invoiceSettings: {
          issuePlace: '',
          comments: '',
          customEmail: '',
          invoiceMailTitle: '',
          invoiceVindicationMailTitle: '',
          customVindicationEmail: '',
          customVindicationSms: ''
        },
        autoReportingFTP: {
          ftpAddress: '',
          ftpPort: '',
          ftpConType: '',
          ftpUser: '',
          ftpPass: '',
          ftpDirectory: ''
        },
        autoReportingList: Array(34).fill(0).map((e, i) => i + 1),
        clientTypesForPartnerUserData: [],
        ksefEnabled: 0,
        sendAllToKsef: 0,
        ksefAccessToken: '',
        ksefAuthorizationType: 1,
        ksefAuthorizationCertificateFile: undefined,
        ksefAuthorizationPrivateKeyFile: undefined,
        ksefSigningCertificateFile: undefined,
        ksefSigningPrivateKeyFile: undefined,
        ksefAuthorizationCertificate: '',
        ksefAuthorizationPrivateKey: '',
        ksefAuthorizationPassphrase: '',
        ksefSigningCertificate: '',
        ksefSigningPrivateKey: '',
        ksefSigningPassphrase: '',
        externalSurveyEmailContent: ''
      }
    }
  },

  created () {
    this.getConfiguration()
    this.getClientTypes()
    this.getInvoiceTypes()
  },
  computed: {
    ...mapGetters({
      invoiceTypeOptions: 'exsbinvoice/list/invoiceTypeOptions'
    })
  },
  methods: {
    checkPagePermission,
    ...mapActions({
      getInvoiceTypes: 'exsbinvoice/list/fetchInvoiceTypeOptions'
    }),
    async getConfiguration () {
      this.configuration = await new ApiService('owners/1').getResults()
      if (!this.configuration.invoiceSettings || this.configuration.invoiceSettings.length === 0) {
        this.configuration.invoiceSettings = {
          issuePlace: '',
          comments: '',
          customEmail: '',
          invoiceMailTitle: '',
          invoiceVindicationMailTitle: '',
          customVindicationEmail: ''
        }
      }
      if (!this.configuration.autoReportingFTP || this.configuration.autoReportingFTP.length === 0) {
        this.configuration.autoReportingFTP = {
          ftpAddress: '',
          ftpPort: '',
          ftpConType: '',
          ftpUser: '',
          ftpPass: '',
          ftpDirectory: ''
        }
      }
      if (!this.configuration.autoReportingList || this.configuration.autoReportingList.length === 0) {
        this.configuration.autoReportingList = Array(34).fill(0).map((e, i) => i + 1)
      }
    },
    async submit () {
      let data = JSON.parse(JSON.stringify(this.configuration))
      if (!data.ksefAccessToken) {
        delete data.ksefAccessToken
      }
      if (!data.ksefAuthorizationPassphrase) {
        delete data.ksefAuthorizationPassphrase
      }
      if (!data.ksefSigningPassphrase) {
        delete data.ksefSigningPassphrase
      }
      if (!data.ksefAuthorizationCertificate) {
        delete data.ksefAuthorizationCertificate
      }
      if (!data.ksefAuthorizationPrivateKey) {
        delete data.ksefAuthorizationPrivateKey
      }
      if (!data.ksefSigningCertificate) {
        delete data.ksefSigningCertificate
      }
      if (!data.ksefSigningPrivateKey) {
        delete data.ksefSigningPrivateKey
      }
      await new ApiService('owners/1').put(data)
    },
    async getClientTypes () {
      let params = { pagination: false }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypesOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      this.clientTypesOptions.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
      this.clientTypesForPartnerUserDataOptions = response.items.map(entry => {
        return {
          value: getId(entry['@id']),
          text: entry.title
        }
      })
    },
    onFileChange (file, type) {
      if (!file) {
        if (type === 'ksefAuthorizationCertificate') {
          this.configuration.ksefAuthorizationCertificate = null
          this.configuration.ksefAuthorizationCertificateFile = null
        } else if (type === 'ksefAuthorizationPrivateKey') {
          this.configuration.ksefAuthorizationPrivateKey = null
          this.configuration.ksefAuthorizationPrivateKeyFile = null
        } else if (type === 'ksefSigningCertificate') {
          this.configuration.ksefSigningCertificate = null
          this.configuration.ksefSigningCertificateFile = null
        } else if (type === 'ksefSigningPrivateKey') {
          this.configuration.ksefSigningPrivateKey = null
          this.configuration.ksefSigningPrivateKeyFile = null
        }
        return
      }
      if (type === 'ksefAuthorizationCertificate') {
        this.configuration.ksefAuthorizationCertificate = null
        this.configuration.ksefAuthorizationCertificateFile = null
      } else if (type === 'ksefAuthorizationPrivateKey') {
        this.configuration.ksefAuthorizationPrivateKey = null
        this.configuration.ksefAuthorizationPrivateKeyFile = null
      } else if (type === 'ksefSigningCertificate') {
        this.configuration.ksefSigningCertificate = null
        this.configuration.ksefSigningCertificateFile = null
      } else if (type === 'ksefSigningPrivateKey') {
        this.configuration.ksefSigningPrivateKey = null
        this.configuration.ksefSigningPrivateKeyFile = null
      }
      if (
        type === 'ksefAuthorizationCertificate' ||
        type === 'ksefAuthorizationPrivateKey' ||
        type === 'ksefSigningCertificate' ||
        type === 'ksefSigningPrivateKey'
      ) {
        this.readCertificateToText(file, type)
      }
    },
    readCertificateToText (file, type) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (type === 'ksefAuthorizationCertificate') {
          this.configuration.ksefAuthorizationCertificate = e.target.result
        } else if (type === 'ksefAuthorizationPrivateKey') {
          this.configuration.ksefAuthorizationPrivateKey = e.target.result
        } else if (type === 'ksefSigningCertificate') {
          this.configuration.ksefSigningCertificate = e.target.result
        } else if (type === 'ksefSigningPrivateKey') {
          this.configuration.ksefSigningPrivateKey = e.target.result
        }
      }
      reader.readAsText(file)
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>

<style scoped>

</style>
